module.exports = __webpack_public_path__ + "static/media/icons-checkout.4341dde0.svg";